export const getItemFromStorage = (key) => localStorage.getItem(key);

export const putItemIntoStorage = (key, value) => localStorage.setItem(key, value);

export const removeItemFromStorage = (key) => localStorage.removeItem(key);

export const clearStorage = () => localStorage.clear();
